import './Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <span>
        Cabana Admin Console &copy; 2026 <a href="https://red7systems.com">Red7 Systems</a>.
      </span>
      <span className="footer__right">Internal Operations Tool</span>
    </footer>
  );
}
